import classNames from 'classnames';
import { QuotePriceText } from 'routes/essential-workspace/components/quote-panel/quote/price-text';
import { PriceQuoteAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/price';
import { QuoteStatus } from 'routes/essential-workspace/components/quote-status';

export function QuotePricedSummary({ className, formId }: { className?: string; formId: string }) {
  return (
    <div className={classNames('flex-x text-start gap-3 justify-content-between w-100', className)}>
      <div className="flex-x gap-2">
        <QuoteStatus variant="icon" formId={formId} />
        <div className="text-truncate overflow-hidden fw-medium">
          <QuotePriceText className="card-title h4 lh-1 mb-0" />
        </div>
      </div>

      <PriceQuoteAction
        className="btn-flat-secondary"
        size="lg"
        iconPosition="icon-only"
        icon={<i className="icon icon-outlined">refresh</i>}
      />
    </div>
  );
}
